import React from "react";
import { Descriptions, Space } from "antd";

import { DATETIME_FORMAT } from "../../../../core/utils/i18n-js";
import { DeleteOutlined } from "@ant-design/icons";

import { PageHeader, Button, Popconfirm, Statistic, Divider } from "antd";

import { QuoteStatusDropdown } from "../../../../components/quote/status";
import TaskList from "../../../../components/quote/qtask/list";

import { isFinalStatus } from "../../../../components/quote/status";

const Details = (props) => {
    const disabled = isFinalStatus(props.record.status);
    const { record } = props;

    const _allowEdit = () => {
        if (record && record.job) {
            return false;
        }

        return true;
    };

    return (
        <>
            <PageHeader
                style={{ margin: 0, padding: 0 }}
                title="Details"
                key="1"
                extra={[
                    <Space size="small" key="0">
                        <QuoteStatusDropdown
                            key="1"
                            onUpdateStatus={props.onUpdateStatus}
                            status={props.record.status}
                            disabled={!_allowEdit()}
                        />
                        {!disabled && (
                            <Popconfirm
                                title="Are you sure?"
                                onConfirm={() => props.onDelete(props.record.id)}
                                okText="Remove"
                                cancelText="No"
                                key="2"
                            >
                                <Button type="dashed" danger icon={<DeleteOutlined />} size="small">
                                    {" "}
                                    Delete
                                </Button>
                            </Popconfirm>
                        )}
                    </Space>,
                ]}
            ></PageHeader>
            <TaskList
                flat
                quote={props.record}
                unitsById={props.unitsById}
                languagesById={props.languagesById}
                languagePairsById={props.languagePairsById}
                servicesById={props.servicesById}
            />
        </>
    );
};

export default Details;
